import { useCallback } from "react";
import { useDashboardRegistry } from "../dashboards/useDashboardRegistry";
import { useSubmitDashboardAccessRequest } from "./useMyDashboardAccessRequests";

// A few older call sites (AccessDenied.tsx, OldCedarHome's InfoBoard, IgniteMs) only know a
// dashboard by its route path, not its real numeric id - POST /user_service/dashboard-access-
// requests (replacing the now-deleted legacy GET /user_service/request-dashboard-access?dashboard=)
// needs that numeric id, so this resolves path -> registry row -> id before submitting. Calls
// onError instead of submitting if no dashboard in the registry matches the given path.
export const useRequestAccessByPath = () => {
  const { dashboards } = useDashboardRegistry();
  const submitMutation = useSubmitDashboardAccessRequest();

  const requestAccessByPath = useCallback(
    (path: string, options?: { onSuccess?: () => void; onError?: () => void }) => {
      const dashboard = dashboards.find((d) => d.path === path);
      if (!dashboard) {
        options?.onError?.();
        return;
      }
      submitMutation.mutate(dashboard.id, { onSuccess: options?.onSuccess, onError: options?.onError });
    },
    [dashboards, submitMutation]
  );

  return { requestAccessByPath, isLoading: submitMutation.isLoading };
};
